export const categories = [
  { slug: 'heixan-baoliao', name: '黑料爆料', icon: 'ri-fire-line', description: '最新最热黑料独家爆料' },
  { slug: 'moli-xiu', name: '莫里秀', icon: 'ri-tv-line', description: '莫里秀全集在线观看' },
  { slug: 'zhao-die', name: '找爹视频', icon: 'ri-search-eye-line', description: '莫里秀找爹经典视频' },
  { slug: 'qinggan-bagua', name: '情感八卦', icon: 'ri-heart-line', description: '情感故事与八卦趣闻' },
  { slug: 'yule-quan', name: '娱乐圈', icon: 'ri-star-line', description: '娱乐圈最新动态' },
  { slug: 'shehui-redian', name: '社会热点', icon: 'ri-global-line', description: '社会热点事件追踪' },
  { slug: 'zhibo-chigua', name: '直播吃瓜', icon: 'ri-live-line', description: '实时吃瓜直播汇总' },
  { slug: 'bagua-shendu', name: '八卦深度', icon: 'ri-file-text-line', description: '深度八卦分析文章' },
];

export const popularTags = [
  '莫里秀', '找爹', '爆料', '内幕', '黑料合集', '情感八卦',
  '51cg', '吃瓜', '在线观看', '最新', '实锤', '独家',
];